<template>
    <div class="conference_main_box">
        <unauthorized-user-meeting-popup v-if="isUnauthorized" />
        
        <before-time-joined-meeting-popup 
            v-else-if="isBeforeScheduleTime && joinedUsrInfo"
            :starts-at="joinedUsrInfo.starts_at" 
            @time-reached="handleMeetingStart" 
        />

        <div v-else id="jitsi-meet-conf-container" class="conference_frame"></div>
    </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import root from "@/_helpers/roots";
import socketMixin from '@/mixins/socketMixin' // 👈 Import your new mixin
import beforeTimeJoinedMeetingPopup from "@/components/private/jitsi/beforeTimeJoinedMeetingPopup.vue";
import unauthorizedUserMeetingPopup from "@/components/private/jitsi/unauthorizedUserMeetingPopup.vue";

const authConferenceInfoApiUrl = root.authConferenceInfoApiUrl.link;

export default {
    name: "jisti-video-conference-auth",
    mixins: [socketMixin],
    components: {
        "before-time-joined-meeting-popup": beforeTimeJoinedMeetingPopup,
        "unauthorized-user-meeting-popup": unauthorizedUserMeetingPopup,
    },
    data() {
        return {
            domain: process.env.VUE_APP_VIDEO_DOMAIN,
            callerRoomId: "",
            selfUserId: "",
            cancelSource: null,

            isBeforeScheduleTime: false,
            isUnauthorized: false, // NEW: State tracker for authorization failures
            joinedUsrInfo: null,
            currentUser: null 
        };
    },
    created() {
        this._api = null;
    },
    mounted() {
        // 2. FIX: Execute the function with parentheses to disconnect when joining
        if (typeof this.closeSocket === "function") {
            this.closeSocket();
        }
        document.body.classList.add("video_conference_page", "zisti_video_main_wrp");
        if (!window.location.hash) {
            window.location.hash =
                Date.now().toString(36) +
                Math.random().toString(36).substring(2);
        }
        this.callerRoomId = window.location.hash.substring(1);
        this.$store.dispatch('fetchCurrentUserInfo').then((res) => {
            this.currentUser = res.data.data;
            this.selfUserId = this.currentUser.id;
            this.initializeMeeting();
        })
    },
    methods: {
        async initializeMeeting() {
            if (!this.currentUser) {
                this.isUnauthorized = true; // Block if user context is missing entirely
                return;
            }

            try {
                const joinedUsrInfo = await this.joinedUserInfoMethod();

                // FIX: If API response marks them unauthorized, or if no Jitsi token is granted
                if (!joinedUsrInfo || !joinedUsrInfo.token || joinedUsrInfo.is_authorized === false) {
                    this.isUnauthorized = true;
                    return;
                }

                this.joinedUsrInfo = joinedUsrInfo;

                // if (this.joinedUsrInfo.starts_at) {
                //     const startTimeMs = new Date(this.joinedUsrInfo.starts_at).getTime() * 1000;
                //     const currentTimeMs = Date.now();
                    
                //     if (currentTimeMs < startTimeMs) {
                //         this.isBeforeScheduleTime = true;
                //         return; 
                //     }

                //     this.joinMeeting();
                // }
                
                this.joinMeeting();

            } catch (error) {
                console.error("Meeting initialization error:", error);
                this.isUnauthorized = true; // Fallback catch to block access on errors
            }
        },

        handleMeetingStart() {
            this.isBeforeScheduleTime = false;
            this.$nextTick(() => {
                this.joinMeeting();
            });
        },

        joinMeeting() {
            if (!this.joinedUsrInfo || this.isUnauthorized) {
                return;
            }

            const displayName = `${this.currentUser.first_name} ${this.currentUser.last_name}`;
            const email = this.currentUser.email;

            this.startMeeting(
                this.callerRoomId,
                displayName,
                email,
                this.joinedUsrInfo
            );
        },

        async joinedUserInfoMethod() {
            this.cancelSource = axios.CancelToken.source();
            try {
                const response = await axios.post(
                    authConferenceInfoApiUrl,
                    { meeting_id: this.callerRoomId},
                    { cancelToken: this.cancelSource.token }
                );
                return response.data.data;
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log("Conference API cancelled.");
                } else {
                    console.error("Conference API Error:", error);
                    // Handle explicit HTTP auth status codes safely
                    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                        this.isUnauthorized = true;
                    }
                }
                return null;
            }
        },

        startMeeting(roomName, displayName, email, joinedUsrInfo) {
            const container = document.getElementById("jitsi-meet-conf-container");
            if (!container || !window.JitsiMeetExternalAPI || this._api) return;

            const options = {
                roomName,
                parentNode: container,
                width: "100%",
                height: "100%",
                jwt: joinedUsrInfo.token,
                userInfo: { displayName, email }
            };

            this._api = new window.JitsiMeetExternalAPI(this.domain, options);
            this.onConferenceJoined = (data) => console.log("Meeting Joined", data);
            this.onReadyToClose = () => {
                this.destroyMeeting();
                window.location.href = "/video/conference/left/room/#" + roomName;
            };

            this._api.addEventListener("videoConferenceJoined", this.onConferenceJoined);
            this._api.addEventListener("readyToClose", this.onReadyToClose);
        },

        destroyMeeting() {
            if (!this._api) return;
            try {
                this._api.removeEventListener("videoConferenceJoined", this.onConferenceJoined);
                this._api.removeEventListener("readyToClose", this.onReadyToClose);
                this._api.dispose();
            } catch (error) {
                console.error(error);
            }
            this._api = null;
        }
    },
    beforeDestroy() {
        document.body.classList.remove("video_conference_page", "zisti_video_main_wrp");
        this.destroyMeeting();
        if (this.cancelSource) { this.cancelSource.cancel("Component destroyed."); }
        // Call the raw connect method explicitly here bypassing route checks.
        if (typeof this.initSocketLifecycle === "function") {
            this.initSocketLifecycle();
        }
    },
};
</script>